/*
  Kokoelma- ja hakusivun suodattimet: Shopifyn storefront filtering + Section Rendering API.
  Valinnat → URL-parametrit (filter.*, sort_by) → Shopify palauttaa rajatut tuotteet.
  Ilman JavaScriptiä lomake toimii tavallisena GET-lomakkeena.
*/
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = $('[data-facet-form]', this);
      this.cache = new Map();
      const onChange = debounce(() => this.submit(), 350);
      this.addEventListener('change', (e) => {
        if (e.target.form === this.form || e.target.getAttribute('form') === this.form.id) onChange();
      });
      this.addEventListener('input', (e) => {
        if (e.target.type === 'number' && e.target.getAttribute('form') === this.form.id) onChange();
      });
      this.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (link) {
          e.preventDefault();
          this.load(new URL(link.href, location.origin).search, link.closest('.pagination') ? 'top' : null);
        }
        const more = e.target.closest('[data-facet-more]');
        if (more) {
          $$('[data-overflow]', more.closest('.facet__body')).forEach((li) => (li.hidden = false));
          more.remove();
        }
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submit();
      });
      window.addEventListener('popstate', () => this.load(location.search, null, false));
    }
    params() {
      const fd = new FormData(this.form);
      const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (String(v).trim() !== '') p.append(k, v);
      // Hinta euroina → Shopify odottaa desimaalilukua
      return p.toString() ? '?' + p.toString() : '';
    }
    submit() {
      this.load(this.params());
    }
    async load(search, scroll = null, push = true) {
      const results = $('[data-facets-results]', this);
      const count = $('[data-facet-count]', this);
      results.setAttribute('aria-busy', 'true');
      const params = new URLSearchParams(search);
      params.set('section_id', this.dataset.section);
      const url = `${this.dataset.url}?${params}`;
      try {
        let html = this.cache.get(url);
        if (!html) {
          const res = await fetch(url);
          if (!res.ok) throw new Error(res.status);
          html = await res.text();
          this.cache.set(url, html);
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = (sel) => $(sel, doc);
        results.innerHTML = fresh('[data-facets-results]')?.innerHTML || '';
        if (count) count.textContent = fresh('[data-facet-count]')?.textContent || '';
        // Suodatinarvojen määrät päivittyvät; avoinna olevat ryhmät säilyvät auki
        const wrap = $('[data-facets-filters-wrap]', this);
        const freshWrap = fresh('[data-facets-filters-wrap]');
        if (wrap && freshWrap) {
          const open = $$('details.facet', wrap).map((d) => d.open);
          const focusedName = document.activeElement?.name;
          const focusedValue = document.activeElement?.value;
          wrap.innerHTML = freshWrap.innerHTML;
          $$('details.facet', wrap).forEach((d, i) => {
            if (open[i] !== undefined) d.open = open[i];
          });
          if (focusedName) {
            const again = $$(`[name="${CSS.escape(focusedName)}"]`, wrap).find((el) => el.type !== 'checkbox' || el.value === focusedValue);
            again?.focus();
          }
        }
        if (push) {
          const clean = new URLSearchParams(search);
          clean.delete('section_id');
          history.pushState({}, '', `${this.dataset.url}${clean.toString() ? '?' + clean : ''}`);
        }
        if (scroll === 'top') this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: this.dataset.section } }));
      } catch {
        window.location.href = `${this.dataset.url}${search}`;
      } finally {
        results.removeAttribute('aria-busy');
      }
    }
  }
  function debounce(fn, ms) {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), ms);
    };
  }
  customElements.define('facet-filters', FacetFilters);
})();
